import React from 'react';
import LegalLayout from '../components/LegalLayout';

const DracoChessSupport: React.FC = () => {
  return (
    <LegalLayout title="DracoChess Support" lastUpdated="September 28, 2026">
      <p>
        Need help with DracoChess, found a bug, or have a suggestion? Reach us at{' '}
        <a href="mailto:service@spiegeleistudio.com">service@spiegeleistudio.com</a> and
        we'll get back to you as soon as we can.
      </p>

      <h2>Frequently Asked Questions</h2>

      <h3>Will I lose my progress if I update the app?</h3>
      <p>
        No. Your adventure progress, skill levels, and puzzle history are saved on your
        device and carry over automatically when you install a new version.
      </p>

      <h3>Do I need an account or internet connection?</h3>
      <p>
        No. DracoChess works fully offline, and there's no sign-in required to play any
        part of the app.
      </p>

      <h3>What if I lose or reset my device?</h3>
      <p>
        Since progress is stored only on your device (see our{' '}
        <a href="/dracochess/privacy">Privacy Policy</a>), it can't currently be recovered
        from a lost or reset device. There's no account to sign back into.
      </p>

      <h3>The narration audio isn't playing - what should I check?</h3>
      <p>
        Lesson narration plays even when your device is set to silent mode, so check that
        your device volume isn't turned all the way down. If it still doesn't play, try
        closing and reopening the app.
      </p>

      <h3>I found a bug or have an idea for a new feature.</h3>
      <p>
        We'd love to hear about it - email us at{' '}
        <a href="mailto:service@spiegeleistudio.com">service@spiegeleistudio.com</a> with
        as much detail as you can (what you were doing, what you expected, and what
        happened instead).
      </p>
    </LegalLayout>
  );
};

export default DracoChessSupport;
